module.exports = __webpack_public_path__ + "img/officePic3s.88422ebd.jpg";